import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class UsersApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/users' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getInfo(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/users/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getAccept(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/users/' + id + '/accept' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async accept(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/users/' + id + '/accept' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdate(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/users/' + id + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async update(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/users/' + id + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async reject(id, data = []) {
		try {
			const response = await axios.put(BASE_URI + '/v1/users/' + id + '/reject' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async block(id, data = []) {
		try {
			const response = await axios.put(BASE_URI + '/v1/users/' + id + '/block' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async unblock(id, data = []) {
		try {
			const response = await axios.put(BASE_URI + '/v1/users/' + id + '/unblock' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async delete(id) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/users/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// Owner รีเซ็ตรหัสผ่านให้ผู้ใช้ที่ลืมรหัส — คืน temporary_password มาครั้งเดียว (api/docs/password-reset.md)
	async resetPassword(id, data = []) {
		try {
			const response = await axios.put(BASE_URI + '/v1/users/' + id + '/reset-password' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

class RolesApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/roles' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCreate(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/roles/create' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async create(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/roles/create' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdate(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/roles/' + id + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async update(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/roles/' + id + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async delete(id) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/roles/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const Users = new UsersApi();
export const Roles = new RolesApi();
